import {makeStyles} from '@logistics-frontend/blocks'

export const useClasses = makeStyles(theme => ({
  container: {
    position: 'absolute',
    top: 0,
    right: 15,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100%',
  },
  buttonsWrap: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: 130,
    minWidth: 42,
  },
  button: {
    width: 40,
    height: 40,
    fontSize: 20,
    backgroundColor: theme.palette.common.white,
    color: theme.palette.secondary.dark,
    '&:hover': {
      backgroundColor: theme.palette.common.white,
    },
    '&:active': {
      backgroundColor: theme.palette.grey[400],
    },
  },
  icon: {
    fontSize: 16,
  },
  geolocationButton: {
    marginTop: 'auto',
    borderRadius: '100%',
  },
  topButton: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  bottomButton: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
}))

export const useTooltipClasses = makeStyles(theme => ({
  popper: {
    zIndex: 3,
  },
  tooltip: {
    backgroundColor: theme.palette.common.white,
    width: 120,
    textAlign: 'center',
    padding: theme.spacing(0.5),
    color: theme.palette.text.primary,
    fontSize: 12,
    lineHeight: '16px',
    // проблема старой темы
    // eslint-disable-next-line
    fontWeight: theme.typography.fontWeightMedium as any,
    boxShadow: '0 8px 20px rgba(117, 115, 111, 0.2)',
  },
  arrow: {
    color: theme.palette.common.white,
  },
}))
